(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/fieldset.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/fieldset.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => ( fieldset)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 

  const Fieldset = props => {
    const classNames = ['control-group'];
    const legendClassNames = ['forms-legend'];
    let legendEl = null;
    if (props.className) {
      classNames.push(props.className);
    }
    if (props.legend) {
      classNames.push('form-fieldset-has-legend');
      if (props.srOnly) {
        legendClassNames.push('sr-only');
      }
      legendEl = React.createElement("legend", {
        className: legendClassNames.join(' ')
      }, props.legend);
    }
    return React.createElement("fieldset", {
      className: classNames.join(' ')
    }, legendEl, props.children);
  };
const fieldset = Fieldset;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Fieldset = __webpack_exports__["default"];
})();

 })(window);